import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const ultraRoutes = {
  [ERouteMappingKeys.ULTRA]: {
    id: "ultra",
    path: "/ultra",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Ultra").then((p) => ({
          default: p.Ultra,
        })),
      ),
    },
  },
};
